export default {
  meta: {
    title: '查看监控',
    parentPath: ['/flow'],
    url: '/overview', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/overview'],
      name: ['概览'],
    },
  },
};
